<template>
  <b-card>
    <div class="mb-2 flex justify-between">
      <h4 class="text-2xl text-black ">
        <strong>Broadcast</strong>
      </h4>
      <div>
        <b-button
          variant="primary"
          @click="$router.push('/broadcast/send-message')"
        >
          Broadcast
        </b-button>
      </div>
    </div>
    <div class="gap-7 lg:w-[70%] grid md:flex">
      <div
        :class="packageLevel > 2 ? 'w-[100%]': 'md:w-[45%]  w-[100%]' "
        class="flex justify-between border  border-1 p-1 rounded-md shadow-md gap-3 items-center"
      >
        <b-img
          fluid
          center
          src="https://storage.googleapis.com/komerce/assets/LP-Komchat/Group-38478.png"
          alt="icon-profile"
        />
        <div class="mt-1">
          <div
            v-if="!whatsAppList.filter(item => item.type === 'komchat' || item.type === 'komchat_ai' ).length"
            class="flex mb-[3px] gap-2 items-center"
          >
            <b-img
              fluid
              src="https://storage.googleapis.com/komerce/assets/icons/danger-yellow.svg"
              alt=""
            />
            <div class="lg:max-w-[13rem] text-black">
              <h6 class="text-black">
                Tidak ada nomor Whatsapp Aktif
              </h6>
            </div>
          </div>
          <div
            v-else
            class="overflow-y-auto  h-[100px] max-h-[100px] p-[5px]"
          >
            <div
              v-for="(item, index) in whatsAppList.filter(item => item.type === 'komchat' || item.type === 'komchat_ai')"
              :key="index"
              class="d-flex  justify-content-between mb-1 border border-1 bg-gray-100 px-[2px] rounded-[8px]"
            >
              <div
                class="mr-1 text-[14px] font-[500] align-self-center p-[5px]"
                :class="!item.is_scan ? 'text-muted' : 'text-black'"
              >
                {{ item.phone_number }}
              </div>
              <img
                :id="`More-Btn-` + item.id"
                src="https://storage.googleapis.com/komerce/assets/komerce-icon/Hitam/more.svg"
                alt=""
              >
              <b-popover
                :target="`More-Btn-` + item.id"
                triggers="hover"
                placement="left"
                custom-class="w-33 z-50 rounded-[8px]"
              >
                <div
                  v-if="!item.is_scan"
                  type="button"
                  class="mb-1"
                  @click="setNumb(item, 'scan')"
                >
                  Scan
                </div>
                <div
                  type="button"
                  class=""
                  @click="setNumb(item, 'delete'); $root.$emit('bv::hide::popover')"
                >
                  Hapus
                </div>
              </b-popover>
            </div>
          </div>
          <!-- <div> -->
          <div
            v-if="!whatsAppList.filter(item => item.type === 'komchat' || item.type === 'komchat_ai' ).length"
            class="py-[8px] text-sm"
          >
            Atur nomor pengirim untuk Broadcast
          </div>
          <b-button
            v-show="!whatsAppList.filter(item => item.type === 'komchat' || item.type === 'komchat_ai' ).length || !whatsAppList.filter(item => item.type === 'komchat').length >= 3"
            size="sm"
            variant="primary"
            class="w-full mt-[5px] text-white"
            @click="$router.push('/opsional-feature/notifikasi-wa-premium')"
          >
            Tambah nomor
          </b-button>
          <!-- </div> -->
        </div>
      </div>
      <div
        v-show="packageLevel > 2"
        class="w-full bg-[url('https://storage.googleapis.com/komerce/assets/LP-Komchat/bg-komchat-coins.svg')] grid bg-no-repeat bg-right-bottom shadow-md gap-6 border p-1 rounded-sm"
      >
        <div class="flex items-center justify-between">
          <div class="flex items-center gap-1">
            <b-img src="https://storage.googleapis.com/komerce/assets/LP-Komchat/icon-komchat-coins.svg" />
            <div class="text-2xl">
              Komchat Coin
            </div>
          </div>
          <div class="">
            <img
              role="button"
              src="https://storage.googleapis.com/komerce/assets/icons/history-icon.svg"
              alt=""
              @click="$router.push('komchat-coins')"
            >
          </div>
        </div>
        <div class="flex items-center gap-2">
          <!-- <b-img src="https://storage.googleapis.com/komerce/assets/LP-Komerce/komchat.svg" /> -->
          <div
            v-show="!isLoadingKomchatCoins"
            class="text-3xl text-[#333333] font-semibold"
          >
            IDR {{ formatBalance(balance) }}
          </div>
          <b-skeleton
            v-show="isLoadingKomchatCoins"
            class="w-full"
            type="input"
          />
        </div>
        <b-button
          variant="outline-primary"
          block
          size="sm"
          @click="$bvModal.show('modal-top-up-komchat-coin')"
        >
          Top up
        </b-button>
      </div>
    </div>
    <div class="mt-3 mb-2">
      <tab
        v-if="packageLevel > 2"
        :tab-active="tabActive"
        @handleTab="handleTab"
      />
    </div>
    <div v-show="tabActive === 'brand'">
      <ForBrandsBroadcast />
    </div>
    <div v-show="tabActive === 'lite'">
      <LiteBroadcast />
    </div>
    <div>
      <ModalValidationAcess :is-expired="isExpiredPackage" />
      <ModalTopUp
        @refreshSaldo="getBalance"
        @handleTopupWithQris="handleTopupWithQris"
      />
      <ScanQRIS
        :qr-bill-detail="dataQris"
        :is-custom="true"
        @paymentSuccess="handlePaymentSuccess"
      />
    </div>
  </b-card>
</template>

<script>
import {
  BCard,
} from 'bootstrap-vue'
import { mapState } from 'vuex'
import tab from '../opsional/wa-notif/komchat/tab.vue'
import { cardBroadcast } from './Broadcast/config'
import ForBrandsBroadcast from './Broadcast/components/ForBrandsBroadcast.vue'
import LiteBroadcast from './Broadcast/components/LiteBroadcast.vue'
import ModalValidationAcess from './Broadcast/components/ModalValidationAccessBroadcast.vue'
import apiGetBalance from './Broadcast/service/api.balance.service'
import ModalTopUp from './Broadcast/components/ModalTopUp.vue'
import ScanQRIS from '../dashboard/modal/ScanQRIS.vue'

export default {
  components: {
    BCard,
    tab,
    ForBrandsBroadcast,
    LiteBroadcast,
    ModalValidationAcess,
    ModalTopUp,
    ScanQRIS,
  },
  data() {
    return {
      cardBroadcast,
      tabActive: this.$route.query.type || 'lite',
      isCanAccessbroadcast: this.$store.state.whatsapp.dashboard_wa.subscription_plan_level > 1,
      isExpiredPackage: this.$store.state.whatsapp.dashboard_wa.whatsapp_expired_at === 0,
      balance: 0,
      isLoading: false,
      packageLevel: this.$store.state.whatsapp.dashboard_wa.subscription_plan_level,
      dataQris: {},
      isLoadingKomchatCoins: false,
    }
  },
  computed: {
    ...mapState('komchat', ['whatsAppList']),
  },
  mounted() {
    this.getBalance()
    this.checkIsCanAccessBroadcast()
    this.$store.dispatch('whatsapp/getUpdateDashboardWa')
  },
  methods: {
    handlePaymentSuccess(message) {
      this.$bvModal.hide('scanQris')
      this.getBalance()
      this.$toast_success({ message })
    },
    handleTopupWithQris(data) {
      this.dataQris = data
      this.$bvModal.show('scanQris')
    },
    handleTab(value) {
      this.tabActive = value
    },
    async checkIsCanAccessBroadcast() {
      await this.$store.dispatch('whatsapp/getUpdateDashboardWa')
      await this.$store.watch(
        state => state.whatsapp.dashboard_wa.subscription_plan_level,
        (newValue, oldValue) => {
          this.isCanAccessbroadcast = newValue
        },
      )
      if (this.$store.state.whatsapp.dashboard_wa === null) {
        this.$bvModal.show('modal-validation-access-broadcast')
      } else if (this.isExpiredPackage) {
        this.$bvModal.show('modal-validation-access-broadcast')
      } else if (!this.isCanAccessbroadcast) {
        this.$router.push('/aplikasiku')
      } else {
        this.$store.dispatch('komchat/getWhatsAppList')
        this.whatsAppList = this.$store.state.komchat.whatsAppList
      }
    },
    async getBalance() {
      try {
        this.isLoadingKomchatCoins = true
        const { data } = await apiGetBalance()
        this.balance = data.data.balance
      } catch {
        this.toast_error({ message: 'Gagal mendapatkan data saldo' })
      } finally {
        this.isLoadingKomchatCoins = false
      }
    },
    formatBalance(number) {
      if (number === null || number === undefined) {
        return '0'
      }
      const parts = number.toString().split('.')
      const integerPart = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.')
      const decimalPart = parts[1] ? `,${parts[1]}` : ''
      return integerPart + decimalPart
    },
    setNumb(data, value) {
      if (value === 'delete') {
        this.$router.push('opsional-feature/notifikasi-wa-premium')
      } else {
        this.$router.push({ name: 'koneksi-wa', params: { number: data } })
      }
    },
  },
}

</script>
